import { ImgHTMLAttributes } from 'react';
import { useS3Image } from '../hooks/useS3Image';

interface S3ImageProps extends Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src'
> {
  src: string | null | undefined;
  thumbnailSrc?: string | null | undefined;
  useThumbnail?: boolean;
  fallback?: React.ReactNode;
}

export function S3Image({
  src,
  thumbnailSrc,
  useThumbnail = true,
  fallback,
  alt,
  ...props
}: S3ImageProps) {
  const imageSrc = useThumbnail && thumbnailSrc ? thumbnailSrc : src;
  const { imageUrl, isLoading, error } = useS3Image(imageSrc);

  if (isLoading) {
    return (
      <div
        className="animate-pulse bg-gray-200 rounded"
        style={{ width: props.width, height: props.height }}
      >
        <span className="sr-only">Loading image…</span>
      </div>
    );
  }

  if (error || !imageUrl) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return (
      <div
        className="bg-gray-100 rounded flex items-center justify-center"
        style={{ width: props.width, height: props.height }}
      >
        <span className="text-gray-400 text-sm">Image unavailable</span>
      </div>
    );
  }

  return <img src={imageUrl} alt={alt} {...props} />;
}
